<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Today's Appointments </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Today's Appointments List</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-success float-right" style="margin-left: 7px;" @click="toggleImportModal">
                                <i class="fas fa-plus"></i> Bulk Add Patient
                            </button>-->
                            <button type="button" class="btn btn-primary float-right" @click="toggleModal">
                              Add New
                            </button>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Search and export area -->
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: center;">Today's Appointment List</h3>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <!-- <div class="">
                                        <label for="from_date"> From </label>
                                        <input type="date" class="form-control" id="from_date" v-model="tableData.from_date" @change="onkeyPress('from_date')">
                                        <div class="invalid-feedback" v-if="errors.from_date">
                                            {{errors.from_date[0]}}
                                        </div>
                                    </div> -->
                                </div>

                                <div class="col-md-3">
                                    <!-- <div class="">
                                        <label for="to_date"> To </label>
                                        <input type="date" class="form-control" id="to_date" v-model="tableData.to_date" @change="onkeyPress('to_date')">
                                        <div class="invalid-feedback" v-if="errors.to_date">
                                            {{errors.to_date[0]}}
                                        </div>
                                    </div> -->
                                </div>

                                <div class="col-md-3 ">
                                    
                                </div>

                                <div class="col-md-3">
                                    <div class="mt-3" style="text-align: right;">
                                        <!-- <button type="submit" class="btn-sm btn btn-primary" :disabled="disabled" @click="filterSalesReport()">
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>Submit 
                                        </button> -->
                                        <a href="javascript:void(0);" style="margin-left: 5px;" class="btn-sm btn btn-primary" @click.prevent="printAppointmentList()" ><i class="mdi mdi-printer-outline me-1"></i> </a>
                                        <!-- <a href="javascript:void(0);" style="margin-left: 5px;" class="btn-sm btn btn-primary"
                                        @click.prevent="downloading ? null : exportToExcel()">
                                            <span v-show="downloading"  >
                                                <i class="fas fa-spinner fa-spin"></i>
                                            </span> 
                                            <i class="mdi mdi-file-excel me-1"></i> 
                                        </a> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Content Area -->
                    <div class="card">
                        <div class="card-body">   
                            <Datatable 
                                :columns="columns" 
                                :sortKey="tableData.sortKey"  
                                @sort="sortBy" 
                                v-if="!loading">
                                <template #header > 
                                    <div class="tableFilters" style="margin-bottom: 10px;">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="control" style="float: left;">
                                                    <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                    <div class="select" style="float: left;">
                                                        <select class="form-select" v-model="tableData.length" @change="getAppointmentList()"> 
                                                            <option value="10" selected="selected">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option :value="pagination.total">All</option>
                                                        </select>
                                                    </div>
                                                    <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-2">
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="getAppointmentList()">
                                            </div>
                                        </div>
                                    </div>   
                                </template> 
                                <template #body >                            
                                    <tbody v-if="appointments.length > 0">
                                        <tr class=" " v-for="(item, i) in appointments" :key="i">
                                            <td>{{ i + 1 }} </td> 
                                            <td>{{ item.appointment_date }}</td>
                                            <td>{{ item.appointment_id }} </td> 
                                            <td>{{ item.patient_name }} </td> 
                                            <td>{{ item.patient_phone }} </td>
                                            <td>{{ item.doctor_name }}</td>
                                            <td>{{ item.department_name }}</td>
                                            <td>
                                                <!-- <a href="javascript:void(0);" @click="updateStatus(item, 1, 'confirmed')" v-if="item.status == 0"><span class="badge bg-warning">Pending</span></a>
                                                <a href="javascript:void(0);" @click="updateStatus(item, 0, 'pending')" v-if="item.status > 0 && item.status < 2"><span class="badge bg-primary">Confirmed</span></a> -->
                                                <a href="javascript:void(0);" @click="updateStatus(item, 2, 'present')" v-if="item.status == 1"><span class="badge bg-danger">Absent</span></a>
                                                <a href="javascript:void(0);" @click="updateStatus(item, 1, 'absent')" v-if="item.status == 2"><span class="badge bg-info">Present</span></a>
                                                <a href="javascript:void(0);" v-if="item.status == 3"><span class="badge bg-success">Done</span></a>
                                            </td>
                                            <td>
                                                <div class="action-btns text-center">
                                                    <!-- item-->
                                                    <a :href="getPaymentReceiveUrl(item.id)" target="_blank" class="btn btn-sm btn-primary" title="Payment Receive">
                                                        <i class="mdi mdi-currency-usd"></i>
                                                    </a> 
                                                    <a href="javascript:void(0);" @click="show(item)" class="btn btn-sm btn-info" title="Patient Details">
                                                        <i class="mdi mdi-eye-outline"></i>
                                                    </a> 
                                                    <a href="javascript:void(0);" class="btn btn-sm btn-warning" @click="edit(item)" title="Edit">
                                                        <i class="mdi mdi-circle-edit-outline"></i>
                                                    </a>
                                                    <a href="javascript:void(0);" class="btn btn-sm btn-danger" @click="deleteItem(item)" title="Delete">
                                                        <i class="mdi mdi-delete-outline"></i>
                                                    </a>
                                                    <!-- item-->
                                                </div>  
                                            </td>
                                        </tr>
                                    </tbody> 
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="8"> No Data Available Here!</td>
                                        </tr>
                                    </tbody>
                                </template> 
                                <template #footer>
                                    <Pagination 
                                        :pagination="pagination"  
                                        :language="lang"
                                        @onChangePage="setPage" > 
                                    </Pagination> 
                                </template> 
                            </Datatable>


                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <Modal @close="toggleModal()" :modalActive="modalActive">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>New Appointment</h3>
                        <button @click="toggleModal()" type="button" class="btn btn-sm btn-danger"> <i class="mdi mdi-close-outline"></i></button>
                    </div>
                    <form @submit.prevent="submitForm()" enctype="multipart/form-data" >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <label for="patient_id" style="float: none;">Patient *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.patient_id"
                                                placeholder="Select Patient"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="patient_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.patient_id">
                                                {{errors.patient_id[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label for="department_id" style="float: none;">Department *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.department_id"
                                                placeholder="Select Department"  
                                                @change="onChangeDepartment($event)"
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="department_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.department_id">
                                                {{errors.department_id[0]}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <label for="doctor_id" style="float: none;">Doctor *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.doctor_id"
                                                placeholder="Select Doctor"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="doctor_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                                v-if="renderOptionComponent"
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.doctor_id">
                                                {{errors.doctor_id[0]}}
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <div class="mb-3">
                                                <label for="appointment_date">Date *</label>
                                                <input type="date" class="form-control border" @keypress="onkeyPress('appointment_date')" v-model="form.appointment_date" id="appointment_date" placeholder="Pulse Rate"> 
                                                <div class="invalid-feedback" v-if="errors.appointment_date">
                                                    {{errors.appointment_date[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div> 
                            </div>
                        </div>
                        <div class="modal-footer"> 
                            <button type="button" class="btn btn-danger" @click="toggleModal()">
                                Close
                            </button> 
                            <button type="submit" class="btn btn-primary " :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span>{{btn}} 
                            </button> 
                        </div>
                    </form>
                </div>
            </Modal>
            
            <!-- Customer Profile Modal -->
            <Modal @close="toggleProfileModal()" :modalActive="showModal">
                <div class="modal-content scrollbar-width-thin customer-show-modal">
                    <div class="modal-header"> 
                        <h5 class="">Details Info</h5>
                        <button @click="toggleProfileModal" type="button" class="btn btn-default">X</button>
                    </div>
                    <div class="modal-body" v-if="customer">  
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-5">    
                                            <img :src="customer.cimage" v-if="customer.cimage" width="200">
                                        </div> <!-- end col -->
                                        <div class="col-lg-7"> 
                                            <!-- Product title -->
                                            <div class="col-md-12">
                                                <h3 class="mt-0">{{ customer.name }}  </h3>  
                                                <table class="table table-responsive">
                                                    <tr>
                                                        <td>Phone: </td>
                                                        <td>{{ customer.phone }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Email: </td>
                                                        <td>{{ customer.email }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address: </td>
                                                        <td>{{ customer.address }}</td>
                                                    </tr>
                                                </table>
                                            </div>  

                                        </div> <!-- end col -->
                                    </div> <!-- end row-->
                                    <div class="table-responsive mt-4">
                                        <table class="table table-bordered table-centered mb-0"> 
                                            <tbody>
                                                <tr>
                                                    <td>Patient Type</td>
                                                    <td>{{ customer.customer_group_name }}</td> 
                                                </tr> 
                                                <tr>
                                                    <td>Gender</td>
                                                    <td>{{ customer.gender }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Date of Birth</td>
                                                    <td>{{ customer.dob }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Blood Group</td>
                                                    <td>{{ customer.blood_group }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Status</td>
                                                    <td>
                                                    <span class="badge bg-success" v-if="customer.status">Active</span> 
                                                    <span class="badge bg-danger" v-else>Inactive</span> 
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td>Address 2</td>
                                                    <td>{{ (customer.address_secondary != 'null') ? customer.address_secondary : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Facebook URL</td>
                                                    <td>{{ (customer.facebook_url != 'null') ? customer.facebook_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Twitter URL</td>
                                                    <td>{{ (customer.twitter_url != 'null') ? customer.twitter_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Instagram URL</td>
                                                    <td>{{ (customer.instagram_url != 'null') ? customer.instagram_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Linkedin URL</td>
                                                    <td>{{ (customer.linkedin_url != 'null') ? customer.linkedin_url : '' }}</td> 
                                                </tr>
                                                
                                            </tbody>
                                            </table>
                                        </div> 
                                    <div class="col-md-12"> 
                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            
                                        </div>
                                    </div>
                                    </div>
                                </div> <!-- end card-body-->
                            </div> <!-- end card-->
                        </div> <!-- end col-->  
                    </div>
                    </div>
                </div>
            </Modal>


            <!-- Print Modal -->
            <Modal @close="togglePrintModal()">
                <div class="modal-content scrollbar-width-thin appointment-print" >
                    <div class="modal-header"> 
                        <button @click="togglePrintModal()" type="button" class="btn btn-default">X</button>
                        <h3 style="width: 100%">Today's Appointment List</h3>
                    </div>
                    <div class="modal-body " id="printArea" >
                        <div class="table-responsive appointment_list">
                            <table class="table po_invoice">
                                <tr>
                                    <td colspan="2" class="text-center" style="position: relative;">
                                        <h5 class="text-uppercase">{{ this.retailShopName }}</h5>
                                        <h6 class="text-uppercase">{{ this.retailSmallText }}</h6>
                                        <p>{{ this.retailShopAddress }} </p>
                                        <p>Dhaka, Bangladesh</p> 
                                        <h4 style="text-align: center;">Today's Appointment List</h4>
                                        <!-- <h5 style="text-align: center;" v-if="from_date != '' && to_date != ''">From {{ from_date }} TO {{ to_date }}</h5> -->
                                    </td>
                                </tr>
                            </table>
                            <table style="width: 100%;" class="table-bordered table-centered table-nowrap">
                                <thead>
                                    <tr>
                                        <th>SL </th>
                                        <th>Date</th>
                                        <th>Appointment ID</th> 
                                        <th>Patient</th> 
                                        <th>Phone</th> 
                                        <th>Doctor</th> 
                                        <th>Department </th> 
                                    </tr>
                                </thead>
                                <tbody v-if="appointments.length > 0">
                                    <tr class="border" v-for="(item, i) in appointments" :key="i">
                                        <td class="text-center">{{ i + 1 }} </td>
                                        <td class="text-left">{{ item.appointment_date }} </td>
                                        <td class="text-left">{{ item.appointment_id }} </td>
                                        <td class="text-left">{{ item.patient_name ?? 'N/A' }} </td>
                                        <td class="text-left">{{ item.patient_phone ?? 'N/A' }} </td>
                                        <td class="text-left">{{ item.doctor_name ?? 'N/A' }} </td>
                                        <td class="text-left">{{ item.department_name ?? 'N/A' }} </td>                                        
                                    </tr> 
                                </tbody>
                            </table> 
                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Appointments',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            imagePreview: '',
            btn:'Create',
            renderOptionComponent: true,
            items: [],
            appointments: [],
            patients: [],
            patient_options: [],
            doctors: [],
            doctor_options: [],
            departments: [],
            department_options: [],
            loading: true,
            companies: [],
            form: new Form({
                id: '',
                patient_id: '', 
                department_id: '',
                doctor_id: '',
                appointment_date: '',   
                status: 0,

            }),
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },            
            columns: [ 
                {
                    label: 'SL',
                    name: '',  
                    isSearch: false, 
                    isAction: true,         
                    width: '5%'
                }, 
                {
                    label: 'Date',
                    name: 'date',
                    width: '10%'
                },    
                {
                    label: 'Appointment ID',
                    name: 'appointment_id',
                    width: '15%'
                },    
                {
                    label: 'Patient',
                    name: 'patient_name',
                    width: '10%'
                },
                {
                    label: 'Phone',
                    name: 'patient_phone',
                    width: '10%'
                },
                {
                    label: 'Doctor',
                    name: 'doctor_name',
                    width: '15%'
                },
                {
                    label: 'Dept.',
                    name: 'department_name',
                    width: '10%'
                },
                {
                    label: 'Status',
                    name: 'status',
                    width: '7%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '18%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 2,
                dir: 'asc',
                sortKey: 'apointment_id', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }

        };
    },
    created() { 
        this.getAppointmentList();
        this.fetchPatients();
        this.fetchDepartments();
        this.fetchDoctors();
    },
    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();  
        },
         
        toggleProfileModal: function() {  
            this.showModal = !this.showModal;
        },

        getPaymentReceiveUrl(appointmentId) {
            return `/accounting/receive-payment?appointment_id=${appointmentId}`;
        },

        printContent(document_id) { 
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS+'/assets/css/print.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 

        fetchPatients() { 
            axios.get(this.apiUrl+'/hm/patients', this.headerjson)
            .then((res) => {
                this.patients = res.data.data;
                // this.patient_options = [{label: "Select Patient", value: ""}];
                res.data.data.map((item) => {
                    this.patient_options.push({label:item.name + " - " + item.phone, value:item.id});
                }); 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        }, 
        fetchDepartments() { 
            axios.get(this.apiUrl+'/hm/departments', this.headerjson)
            .then((res) => {
                this.departments = res.data.data; 
                // this.department_options = [{label: "Select Department", value: ""}];
                res.data.data.map((item) => {
                    this.department_options.push({label:item.name, value:item.id});
                });
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 

         // Products Data
        fetchDoctors() {
            axios.get(this.apiUrl+"/hm/doctors", this.headerjson)
            .then((resp) => {
                this.doctors  = resp.data.data;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        onChangeDepartment(dept_id) {

            this.forceRerender();

            if(dept_id != 0) {
                let department_doctors = this.doctors.filter((item, index) => {
                    return item.department_id == dept_id;
                });

                if(department_doctors.length > 0) {
                    this.doctor_options = department_doctors.map((item) => { 
                        return {label:item.name, value:item.id};
                    });
                }
            }

        },

        show: function(item) {     
            axios.get(this.apiUrl+'/customers/'+item.id, this.headers).then(res => {
                if(res.status == 200){  
                    this.customer = res.data.data
                    this.showModal = !this.showModal;  
                }else{
                    this.$toast.error(res.data.message);
                }
                console.log(res.data.data)
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            }) 
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            let department_doctors = this.doctors.filter((doctor, index) => {
                    return doctor.department_id == item.department_id;
            });

            if(department_doctors.length > 0) {
                this.doctor_options = department_doctors.map((item) => { 
                    return {label:item.name, value:item.id};
                });
            }

            this.form.fill(item);  
        },
        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();              
            formData.append('patient_id', this.form.patient_id);
            formData.append('department_id', this.form.department_id);
            formData.append('doctor_id', this.form.doctor_id);
            formData.append('appointment_date', this.form.appointment_date);
            formData.append('status', this.form.status);

            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/hm/appointments/'+this.form.id, formData, this.headers);
            }else{  
                var postEvent = axios.post(this.apiUrl+'/hm/appointments', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.getAppointmentList();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        // onImageChange(e) {
        //     this.form.cimage = e.target.files[0]
        //     let files = e.target.files || e.dataTransfer.files;
        //     if (!files.length)
        //         return;  
            
        //     this.createImage(files[0]);

        // },
        // createImage(file) {
        //     let reader = new FileReader();
        //     let vm = this;
        //     reader.onload = (e) => { 
        //         vm.imagePreview = e.target.result;
        //     };
        //     reader.readAsDataURL(file);
        // },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        updateStatus: function(item, status, type) {
            var statusText = 'You want to update this appointment?';
            if(type == 'confirmed') {
                statusText = 'You want to '+type+' this appointment?';
            }

            if(type == 'pending') {
                statusText = 'You want to '+type+' this appointment?';
            }

            if(type == 'present') {
                statusText = 'This appointment patient is '+type+'?';
            }

            if(type == 'absent') {
                statusText = 'This appointment patient is '+type+'?';
            }

            const formData = new FormData();              
            formData.append('status', status);
            formData.append('_method', 'put');

            this.$swal({
                title: 'Are you sure?',
                text: statusText, 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Confirm'
            }).then((result) => { 
                if (result.value) { 
                    var postUpdateEvent = axios.post(this.apiUrl+'/hm/appointments/status_update/'+item.id, formData, this.headers);
                    postUpdateEvent.then(res => {
                        if(res.status == 200){  
                            this.getAppointmentList();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this appointment!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/appointments/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.getAppointmentList();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        // For Pagination 
        getAppointmentList(url = this.apiUrl+'/hm/appointments/today') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.appointments = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getAppointmentList();
        },
        setPage(data){  
            this.getAppointmentList(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        printAppointmentList: function () {   
            this.printContent('printArea');
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 700px
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>